import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import { tooltipStyles as styles } from './styles'


const useStylesArrow = makeStyles(styles);

export default function QTooltip(props) {
  const { arrow, paper, ...classes } = useStylesArrow();
  const [arrowRef, setArrowRef] = React.useState(null);

  return (
    <Tooltip
      classes={classes}
      PopperProps={{
        disablePortal: true,
        popperOptions: {
          modifiers: {
            arrow: {
              enabled: Boolean(arrowRef),
              element: arrowRef,
            },
          },
        },
      }}
      {...props}
      title={
        <Paper className={paper}>
          {props.content}
          <span className={arrow} ref={setArrowRef} />
        </Paper>
      }
    />
  );
}

QTooltip.propTypes = {
  content: PropTypes.node,
};